import React from "react";
import "../styles/StatsPage.css";

const StatsPage = () => {
  return (
    <div className="stats-container">
      <h1>Stats Page</h1>
      <p>More insights and data will be displayed here...</p>
    </div>
  );
};

export default StatsPage;
